if (!customElements.get('show-menu-button')) {
  customElements.define(
    'show-menu-button',
    class ShowMenuButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('a');
        button.addEventListener('click', (event) => {
          event.preventDefault();

          let otherButtons = document.querySelectorAll('.mega-menu__main__tablist .mega-menu__link.active');
          for (let i = 0; i < otherButtons.length; i++) {
            otherButtons[i].classList.remove('active');
          }

          button.classList.add('active');

          const elementToShow = document.querySelector(button.getAttribute('href'));

          const otherElements = document.querySelectorAll('ul.mega-menu__list > li');

          for (let i = 0; i < otherElements.length; i++) {
            otherElements[i].classList.add('hidden');
          }

          if (elementToShow) {
            elementToShow.classList.remove('hidden');
          }
        });
      }
    }
  );
}
